<template>
  <el-dialog
    title="修改结业信息"
    :visible.sync="dialogInfo.show"
    :close-on-click-modal="false"
    @close="handleClose"
    destroy-on-close
    width="600px"
  >
    <el-form
      :model="memberInfo"
      ref="ruleForm"
      :rules="rules"
      label-width="130px"
      class="form"
      size="small"
    >
      <el-form-item label="优秀学员：" prop="isExcellent">
        <el-radio-group v-model="memberInfo.isExcellent">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="结业状态：" prop="graduationStatus">
        <el-select
          class="select-content"
          v-model="memberInfo.graduationStatus"
          placeholder="请选择结业状态"
        >
          <el-option
            v-for="(item, i) in graduateTypeList"
            :key="i"
            :label="item.paramValue"
            :value="Number(item.paramKey)"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="集中培训学时数：" prop="obtainedCredit" v-if="memberInfo.classCreditType == 1">
        <div>{{ memberInfo.graduationStatus == 0 ? 0 : memberInfo.obtainedCredit || 0 }}</div>
      </el-form-item>
      <el-form-item label="备注：" >
        <div class="credit-tips">
          <p>1、当前班级最高可获得网络自学学时数：必修课总学时：{{memberInfo.requireCredit || 0}}，考试最高学时：{{memberInfo.examCredit || 0}}，作业最高学时：{{memberInfo.workCredit || 0}}，选修课总学时：{{memberInfo.electiveCoursesCredit || 0}}。</p>
          <p>2、如果当前班级可获得学时类型为“集中培训学时”，则除选修课外获得的网络自学学时可1:1转换为集中培训学时数。</p>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="handleClose" title="取消"></butn>
      <butn btntype="primary" @click="submitForm" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { onlineUpdateGraduationStatus, onlineGraduationInfo } from "@/api/enrollment.js";

export default {
  components: { butn },
  props: {
    dialogInfo: {
      type: Object,
      default: () => {
        return {
          show: false,
          member: {},
        };
      },
    },
    graduateTypeList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    nowRow: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      memberInfo: {
        uuid: "",
        isExcellent: null,
        graduationStatus: null,
        classCreditType: 1,
      },
      rules: {
        isExcellent: [{ required: true, trigger: "blur" }],
        graduationStatus: [{ required: true, message: "请选择结业状态" }],
      },
    };
  },
  mounted() {
    const {
      uuid,
      isExcellent,
      graduationStatus,
    } = this.dialogInfo.member;
    this.memberInfo = {
      uuid,
      isExcellent,
      graduationStatus,
    };
    this.getGraduationInfo();
  },
  methods: {
    handleClose() {
      this.$emit("close", false);
    },
    // 学员班内请假时长
    getGraduationInfo() {
      onlineGraduationInfo({ uuid: this.dialogInfo.member.uuid }).then(
        ({ code, data }) => {
          if (code !== 0) return;
          this.memberInfo = {
            ...this.memberInfo,
            ...data,
          }
        }
      );
    },
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          onlineUpdateGraduationStatus({
            studentUuid: this.memberInfo.studentUuid,
            isExcellent: this.memberInfo.isExcellent,
            graduationStatus: this.memberInfo.graduationStatus,
          }).then(({ code, msg }) => {
            if (code !== 0) return;
            this.$message({
              type: "success",
              message: msg,
            });
            this.$emit("close", true);
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100% !important;
}
.m-t-8 {
  margin-top: 8px;
}
.credit-tips  {
  p {
    padding: 0;
    margin: 0;
    line-height: 20px;
  }
}
</style>
